module.exports = __webpack_public_path__ + "static/media/p6.cdfa99a5.jpg";